"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardRowCheckBoxEditor_1 = require("../../../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowTextEditor_1 = require("../../../../../../../../shared/components/editors/CardRowTextEditor");
var EventBindingOnLoginCfgEditor = /** @class */ (function (_super) {
    __extends(EventBindingOnLoginCfgEditor, _super);
    function EventBindingOnLoginCfgEditor(props) {
        return _super.call(this, props) || this;
    }
    EventBindingOnLoginCfgEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            this.props.data.LoadData(this.props.record.key, function () {
                _this.setState({
                    is_bonus_create_only_on_useragent_part: _this.props.data.DATA.is_bonus_create_only_on_useragent_part,
                    useragent_part_to_bonus_create_on: _this.props.data.DATA.useragent_part_to_bonus_create_on,
                });
            });
        }
        this.setState({
            is_bonus_create_only_on_useragent_part: false,
            useragent_part_to_bonus_create_on: "",
        });
        //
        this.props.state.setExtBreadCrumbPath(["\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u0430 - [" + this.props.record.title + "]"]);
        this.doReSetRules();
    };
    EventBindingOnLoginCfgEditor.prototype.doReSetRules = function () {
        this.setState({
            useragent_part_to_bonus_create_on_rules: { isError: false },
        });
    };
    EventBindingOnLoginCfgEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if (this.state.is_bonus_create_only_on_useragent_part) {
            if ((!this.state.useragent_part_to_bonus_create_on) || (this.state.useragent_part_to_bonus_create_on.length == 0)) {
                this.setState({
                    useragent_part_to_bonus_create_on_rules: { isError: true, errorMessage: "Поле [юзерагент] заполнено некорректно!" },
                });
                return false;
            }
        }
        return true;
    };
    EventBindingOnLoginCfgEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                event_binding_id: this.props.record.key,
                is_bonus_create_only_on_useragent_part: this.state.is_bonus_create_only_on_useragent_part,
                useragent_part_to_bonus_create_on: this.state.useragent_part_to_bonus_create_on,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Настройки обработичка события <логин> изменены!");
            });
        }
    };
    EventBindingOnLoginCfgEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    EventBindingOnLoginCfgEditor.prototype.getFormTitle = function () {
        return "Изменить настройки обработчика события <логин>";
    };
    EventBindingOnLoginCfgEditor.prototype.getActionButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: true, title: { btnEdit: "Сохранить", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    EventBindingOnLoginCfgEditor.prototype.getContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Создавать бонус (1 раз) только при наличии указанной ниже строки в поле <юзерагент>", value: this.state.is_bonus_create_only_on_useragent_part, onChecked: function (checked) {
                    _this.setState({
                        is_bonus_create_only_on_useragent_part: checked
                    });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Юзерагент:", placeholder: "Введите часть поля юзерагент" }, value: this.state.useragent_part_to_bonus_create_on, onValueChanged: function (newVal) {
                    _this.setState({
                        useragent_part_to_bonus_create_on: newVal,
                        useragent_part_to_bonus_create_on_rules: { isError: false }
                    });
                }, required: this.state.is_bonus_create_only_on_useragent_part, rules: this.state.useragent_part_to_bonus_create_on_rules }),
            this.getActionButtons()));
    };
    EventBindingOnLoginCfgEditor.prototype.render = function () {
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 300 }, this.getContent()));
    };
    return EventBindingOnLoginCfgEditor;
}(React.Component));
exports.default = EventBindingOnLoginCfgEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_events_bindings/ui/component/event_config/on_login/EventBindingOnLoginCfgEditor.tsx
// module id = 1987
// module chunks = 0